import React from 'react';

interface FundOption {
    value: string;
    label: string;
}

interface FundSelectorProps {
    fund: string;
    options: FundOption[];
    onChange: (value: string) => void;
}

const FundSelector: React.FC<FundSelectorProps> = ({
    fund,
    options,
    onChange
}) => {
    return (
        <div className="flex items-center text-sm">
            <label htmlFor="fund-designation" className="font-medium text-gray-700 mr-2">
                Fund
            </label>
            <select
                id="fund-designation"
                name="fund_designation"
                value={fund}
                onChange={(e) => onChange(e.target.value)}
                className="pl-2 pr-8 py-1 border-gray-300 focus:outline-none focus:ring-4 focus:ring-[#a5c8fa] focus:ring-opacity-50 focus:border-[#3371e6] rounded-md"
            >
                {options.map(fund => (
                    <option key={fund.value} value={fund.value}>{fund.label}</option>))}
            </select>
        </div>
    );
};

export default FundSelector;
